module.exports = process.env.NODE_ENV === 'debug' // || process.env.DEBUG = true
